module.exports = __webpack_public_path__ + "static/img/3_IMG_20151228_164006.f8f6d38a.jpg";